import Search from './serarch.vue'
export default Search



// WEBPACK FOOTER //
// ./src/components/search/index.js